import { render, staticRenderFns } from "./OpinionGraph.vue?vue&type=template&id=749b2c10&scoped=true"
import script from "./OpinionGraph.vue?vue&type=script&lang=js"
export * from "./OpinionGraph.vue?vue&type=script&lang=js"
import style0 from "./OpinionGraph.vue?vue&type=style&index=0&id=749b2c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749b2c10",
  null
  
)

export default component.exports